





































































import moment, { Moment } from 'moment'

import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  InfiniteScroll,
  NetworkErrorEmptyState,
  OrderTile,
  PaceMaker,
  VsLoading
} from '@/components'

import { EmptyState, ListHeader, MobileLayout } from '@/layouts/components'

import { ActionButton, AsyncState, Order } from '@/models'

import { RootState } from '@/store/state'

import { isFood } from '@/utils'

@Component({
  components: {
    EmptyState,
    InfiniteScroll,
    ListHeader,
    MobileLayout,
    NetworkErrorEmptyState,
    OrderTile,
    PaceMaker,
    VsLoading
  }
})
export default class Orders extends Vue {
  loadState = new AsyncState()

  now = moment()

  get buttons (): ActionButton[] {
    return [
      {
        icon: 'filter_list',
        color: 'dark',
        handler: () => { this.$router.push({ name: 'ChangeOrderFilters' }) }
      }
    ]
  }

  get orderGroups () {
    const today = this.now.clone().startOf('day')

    return this.orderGroupsByDay.map(([day, groupedOrders]) => ({
      day,
      groupedOrders,
      isToday: day.isSame(today)
    }))
  }

  get total (): number {
    return this.orders.length
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.ordering.orders.isDefaultFilters)
  readonly isDefaultFilters!: boolean

  @State((state: RootState) => state.ordering.orders.didLoadAll)
  readonly didLoadAll!: boolean

  @Getter('ordering/filteredOrders')
  readonly orders!: Order[]

  @Getter('ordering/orderGroupsByDay')
  readonly orderGroupsByDay!: [Moment, Order[]][]

  @Action('ordering/loadOrderPage')
  loadOrderPage!: () => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadOrderPage()
    )

    return this.orders.length > 0
  }
}
